import useHasAccessToAirAmbulance from '@rsos/hooks/useHasAccessToAirAmbulance';
import useHasAccessToTowPro from '@rsos/hooks/useHasAccessToTowPro';

/**
 * Whether the user can reach the Resource Request panel: true when any
 * resource request type (Air Ambulance, TowPro) is available to them.
 */
const useHasAccessToResourceRequests = (): boolean => {
  const hasAccessToAirAmbulance = useHasAccessToAirAmbulance();
  const hasAccessToTowPro = useHasAccessToTowPro();

  return hasAccessToAirAmbulance || hasAccessToTowPro;
};

export default useHasAccessToResourceRequests;
